import { createStore as createReduxStore, applyMiddleware, compose } from 'redux'
import { rootReducer } from './reducers'
import thunk from 'redux-thunk'

const createStore = () => {
    const composedEnhancer = compose(
        applyMiddleware(thunk),
        window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
    )
    return createReduxStore(rootReducer, composedEnhancer)
}

export const store = createStore();